import { assignStudioQuery } from '.';
import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType } from '../../model';
import {
  IBalanceItem,
  IBillListItem,
  IBillMonthCost,
} from '../../model/billing-center/balance';
import { BILLING_PROXY_VIEW } from '../config';

// 收支明细-列表
export const getBalanceInfoList = (
  studioId: string,
  startDate: string,
  endDate: string,
  isZero: boolean
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(
        `${BILLING_PROXY_VIEW}/api/account/exchange_detail`
      );
      const response = await api.commonRequest('GET', url, {
        studio_id: studioId,
        start_date: startDate,
        end_date: endDate,
        page: 1,
        size: 9999,
        isZero,
      });
      const res = await parsedResponse<IBalanceItem>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: getBalanceInfoList', error);
      return null;
    }
  });

// 账单列表
export const getBillList = (
  studioId: string,
  // date: string,
  page: number,
  size: number
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(`${BILLING_PROXY_VIEW}/api/bill/list`);
      const response = await api.commonRequest('GET', url, {
        studio_id: studioId,
        // date,
        page,
        size,
      });
      const res = await parsedResponse<IBillListItem>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: getBillList', error);
      return null;
    }
  });

// 账单管理-本月消费
export const getBillMonthCost = (studioId: string, date: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(
        `${BILLING_PROXY_VIEW}/api/consume/month_cost`
      );
      const response = await api.commonRequest('GET', url, {
        studio_id: studioId,
        date,
      });
      const res = await parsedResponse<IBillMonthCost>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: getBillMonthCost', error);
      return null;
    }
  });
